/**
 * **시너지 도감 발견 추적** — 전투 중 활성 경로 조합으로 발동한 시너지의 최초 발견을 영속한다.
 * 최초 발견 시에만 보상을 1회 지급하기 위한 dedup 게이트(매 발사 중복 지급 방지). 순수 도메인 무관(Set 래퍼) —
 * Phaser/보상 sink 무의존. 선례 [AnalyticsMilestoneController]와 동형(Set 내부 / 배열 직렬화).
 *
 * 영속: SaveData.discoveredSynergyIds(string[])로 직렬화(SaveCodec) + 번들 스왑(saveSwap)으로 reload 복원.
 * 호출자 규약: `if (ctx.moduleSynergy().discover(id)) { 최초 발견 보상 + 토스트 + persist }`.
 */
export class ModuleSynergyController {
  private readonly discovered: Set<string>;

  constructor(initial?: Iterable<string>) {
    this.discovered = new Set(initial);
  }

  /** SaveData.discoveredSynergyIds(string[])에서 복원. undefined(신규 계정)이면 빈 Set으로 초기화. */
  static fromState(state: readonly string[] | undefined): ModuleSynergyController {
    return new ModuleSynergyController(state ?? []);
  }

  /** 이미 발견한 시너지인지 (부수효과 없이 조회) — 도감 발견/미발견 표시에 사용. */
  hasDiscovered(id: string): boolean {
    return this.discovered.has(id);
  }

  /** 첫 발견만 true(+기록), 이후 false. 최초 발견 보상 1회 지급의 단일 게이트. */
  discover(id: string): boolean {
    if (this.discovered.has(id)) return false;
    this.discovered.add(id);
    return true;
  }

  /** 발견한 시너지 id 배열을 반환. SaveCodec이 SaveData.discoveredSynergyIds에 직렬화한다. */
  toState(): string[] {
    return [...this.discovered];
  }
}
